export default __webpack_public_path__ + "static/logo-color-08f8eb71cc37be0d2bc908dd6e6ca23d.png";